export default __webpack_public_path__ + "static/media/36I-102707_-15701_0.88909440.jpg";